import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { apiOrganization } from "../../../../../../../../../../../../services/Api/Organization/apiOrganization";
import {
	CompanyApi,
	InvoiceCalculationType,
	InvoiceDetailsApi,
} from "../../../../../../../../../../../../services/Api/Organization/types";
import CompanyInfoNotFullAlert from "../../../../../Invoice/Alerts/CompanyInfoNotFullAlert";
import NoInvoiceDetailsAlert from "../../../../../Invoice/Alerts/NoInvoiceDetailsAlert";
import InvoiceForm from "../../../../../Invoice/components/InvoiceForm/InvoiceForm";
import {
	checkIfCanRenderInvoiceForm,
	checkIfRenderNoInvoiceDetailsAlert,
	checkIfRenderNotFullCompanyInfo,
} from "../../../../../Invoice/services";
import { OrderContext } from "../../../../pages/Preview";

const OrganizationOrderOrdersInvoiceNewPage = () => {
	const { orderInvoiceCustomFieldsConfig, order, orderInvoices } = useContext(OrderContext);
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const [invoiceDetails, setInvoiceDetails] = useState<InvoiceDetailsApi | undefined>();
	const [companyInfo, setCompanyInfo] = useState<CompanyApi | undefined>();
	const { addFlash } = useFlash();
	const history = useHistory();
	const organization = useSelector(selectOrganization);

	const handleRedirect = () => {
		if (orderInvoices && orderInvoices.length > 0) {
			history.replace(
				`/${organization.id}/documents/sales/${order.id}/invoices/${orderInvoices[orderInvoices.length - 1].id}`
			);
		}
	};

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		handleRedirect();
		handleChangeTabTitle(
			`${order.document_number} | ${t("modules.order.header.title")} | ${t(
				"modules.order.field.new_invoice.title"
			)}`
		);

		await fetchInvoiceDetails();
		await fetchCompanyInfo();
	};

	const fetchInvoiceDetails = async () => {
		try {
			const res = await apiOrganization.getInvoiceDetails();
			setInvoiceDetails(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchCompanyInfo = async () => {
		try {
			const res = await apiOrganization.getCompany({ include: "all" });
			setCompanyInfo(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!orderInvoiceCustomFieldsConfig || !invoiceDetails || !companyInfo) return <LoadingContainer />;

	return (
		<div>
			<Header title={t("modules.order.field.new_invoice.title")} />
			{checkIfRenderNoInvoiceDetailsAlert(invoiceDetails) && <NoInvoiceDetailsAlert />}
			{checkIfRenderNotFullCompanyInfo(companyInfo) && <CompanyInfoNotFullAlert />}
			{checkIfCanRenderInvoiceForm(invoiceDetails, companyInfo) && (
				<InvoiceForm
					customFieldsConfig={orderInvoiceCustomFieldsConfig}
					invoiceDetails={invoiceDetails}
					withoutItems
					calculationType={order.tax_gross ? InvoiceCalculationType.GROSS : InvoiceCalculationType.NET}
					orders={[
						{
							id: null,
							order_id: Number(order.id),
							order_number: order.document_number,
							order_sale_date: order.ordered_at,
							order_tax_id_no: "",
						},
					]}
				/>
			)}
		</div>
	);
};

export default OrganizationOrderOrdersInvoiceNewPage;
